'use client'
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface PopupContextType {
    popup: {
        status: number, // 0: success, 1: error, 2: warning, 3: info
        title: string,
        message: string,
        yesAction?: () => void,
        noAction?: () => void,
        defaultAction?: () => void
    };
    setPopup: React.Dispatch<React.SetStateAction<{
        status: number;
        title: string;
        message: string;
        yesAction?: () => void;
        noAction?: () => void;
        defaultAction?: () => void;
    }>>;

    showPopup: boolean;
    setShowPopup: React.Dispatch<React.SetStateAction<boolean>>;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const usePopup = () => {
    const context = useContext(PopupContext);
    if (!context) {
        throw new Error('usePopup must be used within a PopupProvider');
    }
    return context;
};

interface PopupProviderProps {
    children: ReactNode;
}

export const PopupProvider: React.FC<PopupProviderProps> = ({ children }) => {
    const [popup, setPopup] = useState<{
        status: number;
        title: string;
        message: string;
        yesAction?: () => void;
        noAction?: () => void;
        defaultAction?: () => void;
    }>({
        status: 0,
        title: '',
        message: '',
        yesAction: undefined,
        noAction: undefined,
        defaultAction: undefined
    });
    const [showPopup, setShowPopup] = useState(false);

    return (
        <PopupContext.Provider value={{ popup, setPopup, showPopup, setShowPopup }}>
            {children}
        </PopupContext.Provider>
    );
}